import { Link } from "react-router-dom";
import { Building2 } from "lucide-react";
import { Eyebrow } from "@/components/ui-custom/Eyebrow";
import { Reveal } from "@/components/ui-custom/Reveal";
import { NJServiceMap } from "@/components/ui-custom/NJServiceMap";
import { AREAS_HERO_IMAGE } from "@/data/media";
import { PreFooterCTA } from "@/components/sections/PreFooterCTA";
import { useSEO, localBusinessSchema } from "@/lib/seo";

export default function ServiceAreas() {
  useSEO({
    title: "Service Areas | NJ Contractor — Monmouth, Union & More",
    description:
      "AIM High serves Monmouth, Union, Middlesex & Ocean County NJ — Colts Neck, Holmdel, Freehold, Marlboro & beyond. NYC property maintenance too.",
    path: "/service-areas",
    jsonLd: [localBusinessSchema()],
  });

  return (
    <>
      {/* Hero */}
      <section className="relative overflow-hidden" style={{ minHeight: "40vh", background: "var(--black)" }} data-testid="areas-hero">
        <div className="absolute inset-0" style={{ background: "var(--charcoal)" }} />
        <img src={AREAS_HERO_IMAGE} alt="Aerial view of a Colts Neck, NJ home" className="absolute inset-0" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
        <div className="absolute inset-0" style={{ background: "linear-gradient(90deg, rgba(9,9,11,0.84) 0%, rgba(9,9,11,0.5) 50%, rgba(9,9,11,0.2) 100%)" }} />
        <div className="absolute inset-0" style={{ background: "linear-gradient(0deg, rgba(9,9,11,0.45) 0%, rgba(9,9,11,0) 45%)" }} />
        <div className="container-1200 relative z-10 flex flex-col justify-center" style={{ minHeight: "40vh", paddingTop: "72px", paddingBottom: "48px" }}>
          <Reveal><Eyebrow start>Service Areas · Central NJ</Eyebrow></Reveal>
          <Reveal delay={0.1}>
            <h1 className="h1 mt-6" style={{ color: "var(--text-light)", maxWidth: "18ch" }} data-testid="areas-h1">
              Areas We Serve in Central New Jersey
            </h1>
          </Reveal>
        </div>
      </section>

      {/* NYC block */}
      <section className="sec-charcoal section-y" data-testid="areas-nyc">
        <div className="container-1200 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          <Reveal>
            <Eyebrow start>Across the River</Eyebrow>
            <h2 className="h2 mt-5" style={{ color: "var(--text-light)" }}>Registered for NYC Property Maintenance</h2>
            <p className="mt-5" style={{ color: "rgba(245,242,236,0.72)", fontSize: "17px", lineHeight: 1.7, maxWidth: "56ch" }}>
              Own or manage property in New York City? We're registered with New York City for property maintenance, so the same reliable, licensed crew can handle your commercial upkeep in the city — not just in New Jersey.
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <div className="flex lg:justify-end">
              <Link to="/commercial/general-maintenance" className="btn btn-primary" data-testid="nyc-cta">
                <Building2 size={17} strokeWidth={1.75} />
                Commercial Maintenance
              </Link>
            </div>
          </Reveal>
        </div>
      </section>

      {/* Map */}
      <NJServiceMap />

      <PreFooterCTA />
    </>
  );
}
